import { Group, SegmentedControl, Text } from '@byecode/ui'
import { FilterVisibleModeEnum } from '@lighthouse/core'
import { ListItem4ByecodeUi, useAtomData } from '@lighthouse/shared'
import React, { useCallback, useDeferredValue } from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { selectedBlockCustomViewAtom } from '@/atoms/page/state'
import { useBlockSettingContext } from '@/contexts/BlockSettingContext'

import { SwitchControl } from '../BlockSettings/Common/SwitchControl'
import { ConditionFilter } from '../ConditionFilter'
import { InheritLabel } from '../InheritLabel'
import { useSetExtendsKeys } from '../StyleSetting/hooks/useMouseEventDistance'

interface VisibilitySettingProps {
    title?: string
    currentDsId?: string
}

export const VisibilitySetting: React.FC<VisibilitySettingProps> = ({ title = '可见性', currentDsId }) => {
    const { control } = useFormContext()
    const { blockId } = useBlockSettingContext()
    const visibility = useWatch({ control, name: 'breakPoint.visibility.visible' })
    const { handleSetBreakKey } = useSetExtendsKeys()
    const isConditionVisibility = visibility === FilterVisibleModeEnum.FILTER
    const isHidden = visibility === FilterVisibleModeEnum.HIDDEN
    const customViewDsId = useDeferredValue(
        useAtomData(
            selectedBlockCustomViewAtom,
            useCallback(s => s?.config.pointer, [])
        )
    )
    return (
        <Group label={title}>
            <ListItem4ByecodeUi justifyContent="space-between" alignItems="center">
                <InheritLabel label="显示规则" name="breakPoint.visibility.visible" />
                <Controller
                    name="breakPoint.visibility.visible"
                    render={({ field }) => (
                        <SegmentedControl
                            data={[
                                { label: '显示', value: FilterVisibleModeEnum.VISIBLE },
                                { label: '隐藏', value: FilterVisibleModeEnum.HIDDEN },
                                { label: '按条件', value: FilterVisibleModeEnum.FILTER }
                            ]}
                            value={field.value}
                            onChange={val => {
                                field.onChange(val)
                                handleSetBreakKey('breakPoint.visibility.visible')
                            }}
                        />
                    )}
                />
            </ListItem4ByecodeUi>

            {isConditionVisibility && (
                <Controller
                    name="breakPoint.visibility.visibilityFilter"
                    control={control}
                    render={({ field: { onChange, value } }) => {
                        const filter = value
                        return (
                            <ConditionFilter
                                label="满足条件时显示"
                                currentBlockId={blockId}
                                currentDsId={currentDsId}
                                viewDsId={customViewDsId}
                                viewType="custom"
                                filter={filter}
                                onFilter={val => {
                                    handleSetBreakKey('breakPoint.visibility.visibilityFilter')
                                    onChange(val)
                                }}
                            />
                        )
                    }}
                />
            )}

            {(isHidden || isConditionVisibility) && (
                <Controller
                    name="breakPoint.visibility.isMount"
                    control={control}
                    render={({ field: { onChange, value } }) => {
                        return (
                            <SwitchControl
                                label={<InheritLabel label="隐藏时仍加载组件数据" name="breakPoint.visibility.isMount" />}
                                checked={!!value}
                                onChange={e => {
                                    onChange(e.target.checked)
                                    handleSetBreakKey('breakPoint.visibility.isMount')
                                }}
                            />
                        )
                    }}
                />
            )}
        </Group>
    )
}
